import React from "react";
import MaterialIcon from "react-google-material-icons";

const splitCredential = (text) => {
  const idx = text.indexOf(":");
  if (idx === -1) return { heading: text, body: "" };
  return { heading: text.slice(0, idx).trim(), body: text.slice(idx + 1).trim() };
};

export const GalleryModal = ({img, heading, text, size, callback}) => {
  const bullets = text;
  return (
    <div className="gallery-modal" onClick={callback}>
      <div className="gallery-modal-panel" onClick={e => e.stopPropagation()}>

        <div className="gallery-modal-img-wrap">
          <img src={img} alt="Not found" className="gallery-modal-img"/>
        </div>

        <div className="gallery-modal-info">
          <div className="gallery-modal-header">
            <h3 className="gallery-modal-title">{heading}</h3>
            <div className="gallery-modal-title-bar"></div>
          </div>
          <ul className="gallery-modal-capabilities">
            {bullets.map((t, i) => {
              const { heading: cap, body } = splitCredential(t.trim());
              return (
                <li key={i} className="gallery-modal-capability-item">
                  <span className="gallery-modal-capability-icon">
                    <MaterialIcon icon="check_circle" size={18}/>
                  </span>
                  <span className="gallery-modal-capability-content">
                    <span className="gallery-modal-capability-heading">{cap}</span>
                    {body && <span className="gallery-modal-capability-body">{body}</span>}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>

        <button className="gallery-modal-close-btn" onClick={callback}>
          <MaterialIcon icon="close" size={22}/>
        </button>

      </div>
    </div>
  );
};
